module.exports = __webpack_public_path__ + "img/customer_value.1a2b4436.png";